import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Box,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import Detalhamento from "./components/Detalhamento";
import { Footer } from "../../components/Footer/Footer";
import { OverviewCardSkeleton } from "../../components/Cards";
import { useOverviewData } from "../../hooks";

function MapaMinaDesktop({ app }) {
  const { isLoading } = useOverviewData(app);
  const [selectedValue, setSelectedValue] = useState("4");

  const handleChange = async (event) => {
    const value = event.target.value;
    try {
      await app.field("CategoriasCompradas").selectMatch(value, true);
      setSelectedValue(value);
    } catch (error) {
      console.error("Erro ao selecionar valor:", error);
    }
  };

  return (
    <div className="app overview">
      <div className="appContent">
        <LayoutWrapper>
          <>
            <Grid
              container
              flexDirection="column"
              justifyContent="flex-start"
              rowGap={2}
            >
              {isLoading ? (
                <Grid container spacing={2} sx={{ marginTop: "37px" }}>
                  <Grid item xs={12}>
                    <OverviewCardSkeleton variant="performance" />
                  </Grid>
                </Grid>
              ) : (
                <Grid item spacing={2}>
                  <Grid
                    container
                    className="container-card-title"
                    alignItems={"center"}
                    sx={{ marginTop: "37px", marginBottom: "20px" }}
                  >
                    <Grid item xs={12} md={4} lg={3} xl={2}>
                      <Typography variant="h1" className="title">
                        Mapa da Mina
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={8} lg={9} xl={10}>
                      <Grid container alignItems="center" spacing={2}>
                        <Grid item xs={12} md={7} lg={7} xl={9} sx={{ display: "flex", justifyContent: "flex-end" }}>
                          <FormLabel component="legend" sx={{ whiteSpace: "nowrap", fontSize: "14px" }}>
                            Categorias Compradas
                          </FormLabel>
                        </Grid>
                        <Grid item xs={12} md={5} lg={4} xl={3}>
                          <FormControl component="fieldset" sx={{ display: "flex", justifyContent: "flex-end", flexDirection: "row" }}>
                            <RadioGroup
                              row
                              value={selectedValue}
                              onChange={handleChange}
                              aria-label="categorias compradas"
                              name="categorias-compradas"
                            >
                              <FormControlLabel
                                value="1"
                                control={<Radio />}
                                label="1"
                              />
                              <FormControlLabel
                                value="2"
                                control={<Radio />}
                                label="2"
                              />
                              <FormControlLabel
                                value="3"
                                control={<Radio />}
                                label="3"
                              />
                              <FormControlLabel
                                value="4"
                                control={<Radio />}
                                label="4"
                              />
                            </RadioGroup>
                          </FormControl>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container spacing={2}>
                    <Grid item xs={12} className="container-tables-tops">
                      <Detalhamento app={app} />
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                position: "relative",
              }}
            >
              <Footer app={app} />
            </Box>
          </>
        </LayoutWrapper>
      </div>
    </div>
  );
}

MapaMinaDesktop.propTypes = {
  app: PropTypes.object,
};

export default MapaMinaDesktop;
